"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INACTIVE_CHANNEL_STATES = exports.INACTIVE_CONNECTION_STATES = void 0;
exports.INACTIVE_CONNECTION_STATES = ['suspended', 'closing', 'closed', 'failed'];
exports.INACTIVE_CHANNEL_STATES = ['failed', 'suspended', 'detaching'];
//# sourceMappingURL=constants.js.map